/**
 * PopupButtonStrategy - Configuration for popup buttons
 * 
 * Implements Open/Closed Principle by making button configuration
 * extensible without modifying the component code.
 */
export class PopupButtonStrategy {
    /**
     * Get the button configuration for a given popup
     * @param {Object} popup - The popup notification object
     * @returns {Array} - Array of button configurations
     */
    static getButtons(popup) {
        const isBlocking = popup.datos.requiereAceptacion;

        if (isBlocking) {
            return [
                {
                    label: 'Aceptar y Continuar',
                    action: 'accept',
                    variant: 'primary'
                }
            ];
        }

        return [
            {
                label: 'Cerrar',
                action: 'close',
                variant: 'secondary'
            }
        ];
    }

    /**
     * Get the action handler name for a button action
     * @param {string} action - The action name ('accept' or 'close')
     * @returns {string} - The handler function name
     */
    static getHandlerName(action) {
        return action === 'accept' ? 'handleAccept' : 'handleClose';
    }
}
